import {
  ArrowsUpDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from '@heroicons/react/20/solid'
import { orderBy } from 'lodash-es'
import moment from 'moment'
import { useEffect, useState } from 'react'
import ReactPaginate from 'react-paginate'
export default function PaginatedTable({
  pastEventsList,
  itemsPerPage,
  activeVal,
  setActive,
}) {
  const [itemOffset, setItemOffset] = useState(0)
  const [sortField, setSortField] = useState([])
  const [order, setOrder] = useState(true)
  const endOffset = itemOffset + itemsPerPage
  const currentItems = sortField.slice(itemOffset, endOffset)
  const pageCount = Math.ceil(sortField.length / itemsPerPage)

  useEffect(() => {
    let sortOrder = pastEventsList.sort((a, b) => {
      const dateA = new Date(a.date)
      const dateB = new Date(b.date)
      return dateB - dateA
    })
    setSortField(sortOrder)
  }, [pastEventsList])

  const changeOrder = (sort, reorder) => {
    switch (sort) {
      case 'events':
        const evorder = orderBy(sortField, 'event', reorder ? 'asc' : 'desc')
        setSortField(evorder)
        setOrder(reorder)
        return
      case 'location':
        const leorder = orderBy(sortField, 'location', reorder ? 'asc' : 'desc')
        setSortField(leorder)
        setOrder(reorder)
        return
      case 'date':
        let dateorder = sortField.sort((a, b) => {
          return new Date(a.date) - new Date(b.date)
        })
        if (reorder) {
          dateorder = dateorder.reverse()
        }
        setSortField(dateorder)
        setOrder(reorder)
        return
      default:
        let deorder = sortField.sort((a, b) => {
          return new Date(b.date) - new Date(a.date)
        })
        setSortField(deorder)
        return
    }
  }

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % sortField.length
    setItemOffset(newOffset)
  }

  return (
    <>
      <EventsTable
        setActive={setActive}
        activeVal={activeVal}
        currentItems={currentItems}
        changeOrder={changeOrder}
        order={order}
        sortField={sortField}
        eventsList={pastEventsList}
      />
      {pastEventsList.length > 0 && (
        <div className="mt-16">
          <p className="text-sm text-[#98A2B3] ">
            Displaying Past Events 1 - {currentItems?.length} of{' '}
            {pastEventsList?.length || 0} in total
          </p>
        </div>
      )}
      <div className="flex flex-col mt-4 mb-16 w-full">
        <ReactPaginate
          breakLabel={'...'}
          nextLabel={
            <div className="relative inline-flex items-center h-[42px] rounded-r-md p-[9px] text-gray-400 ring-1 ring-inset ring-[#1A1D21] hover:bg-zinc-900 focus:z-20 focus:outline-offset-0">
              <span className="sr-only">Next</span>
              <ChevronRightIcon
                className="h-5 w-5 text-[#6B7280]"
                aria-hidden="true"
              />
            </div>
          }
          onPageChange={handlePageClick}
          pageCount={pageCount}
          previousLabel={
            <div className="relative inline-flex items-center h-[42px] rounded-l-md p-[9px] text-gray-400 ring-1 ring-inset ring-[#1A1D21] hover:bg-zinc-900 focus:z-20 focus:outline-offset-0">
              <span className="sr-only">Previous</span>
              <ChevronLeftIcon
                className="h-5 w-5 text-[#6B7280]"
                aria-hidden="true"
              />
            </div>
          }
          renderOnZeroPageCount={null}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          containerClassName={'flex items-center justify-center w-full '}
          pageClassName={'paginatie-li'}
          activeClassName={'paginate-active-li'}
          pageLinkClassName={
            'relative inline-flex h-[42px] items-center px-[17px] py-[9px] text-sm font-semibold text-[#6B7280] ring-1 ring-inset ring-[#1A1D21] hover:bg-zinc-900 focus:z-20 focus:outline-offset-0'
          }
          activeLinkClassName={
            'relative z-10 inline-flex items-center px-[17px] py-[9px] text-sm font-semibold active-paginate-link ring-1 ring-inset ring-[#1A1D21] focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600'
          }
          breakClassName={'px-4 text-sm text-gray-600 cursor-pointer'}
          previousClassName={'paginate-prev-li h-[42px]'}
          previousLinkClassName={'paginate-prev-a h-[42px]'}
          nextClassName={'paginate-next-li h-[42px]'}
          nextLinkClassName={'paginate-next-a h-[42px]'}
          disabledClassName={'paginate-disabled-btn cursor-not-allowed '}
          disabledLinkClassName={'paginate-disabled-btn-a cursor-not-allowed '}
        />
      </div>
    </>
  )
}

function EventsTable({ setActive, activeVal, currentItems }) {
  const [isAsc, setIsAsc] = useState(true)

  const handleClick = (val) => {
    if (activeVal === val) {
      setIsAsc(!isAsc)
    } else {
      setActive(val)
      setIsAsc(true)
    }
  }

  const parseDate = (dateString) => {
    const monthNames = {
      January: 0,
      February: 1,
      March: 2,
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
    }

    // Match strings like "November 16, 2023"
    const parts = dateString.match(/^(\w+)\s(\d{1,2}),\s(\d{4})$/)
    if (!parts) {
      console.error('Invalid date format:', dateString)
      return new Date(NaN) // Return an invalid date
    }

    const [, monthName, day, year] = parts
    const monthIndex = monthNames[monthName]

    if (monthIndex === undefined) {
      console.error('Invalid month name:', monthName)
      return new Date(NaN) // Invalid month
    }

    return new Date(parseInt(year, 10), monthIndex, parseInt(day, 10))
  }

  const eventsFilter = (eventsList, activeVal) => {
    const currentDate = new Date()
    currentDate.setHours(0, 0, 0, 0)

    let sortedEvents = [...eventsList].filter((event) => {
      const eventDate = new Date(event.date)
      return eventDate < currentDate
    })

    if (activeVal === 'Name') {
      sortedEvents.sort((a, b) => a.heading.localeCompare(b.heading))
    } else if (activeVal === 'Date') {
      sortedEvents.sort((a, b) => parseDate(a.date) - parseDate(b.date))
    } else if (activeVal === 'Location') {
      sortedEvents.sort((a, b) => a.location.localeCompare(b.location))
    }

    if (!isAsc) {
      sortedEvents.reverse()
    }

    return sortedEvents
  }

  const filteredEventsList = eventsFilter(currentItems, activeVal)

  return (
    <div className="pl-2 pr-8 sm:px-10 lg:px-8 w-full xl:w-auto">
      <div className="mt-4 flow-root ml-0  w-full">
        <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8 w-full">
          <div className="inline-block  py-2 align-middle ">
            <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 sm:rounded-lg border border-zinc-700 max-w-7xl">
              <table className=" max-w-7xl divide-y divide-gray-700">
                <thead className="bg-neutral-900 ">
                  <tr className="w-full">
                    <th
                      onClick={() => handleClick('Name')}
                      scope="col"
                      className="px-6 flex items-center py-3 xl:w-[470px] cursor-pointer bg-neutral-900  text-left text-[16px] leading-[16px] font-semibold text-white"
                    >
                      <div className="flex items-center gap-2">
                        Events
                        <ArrowsUpDownIcon className="w-5 h-5" />
                      </div>
                    </th>
                    <th
                      onClick={() => handleClick('Location')}
                      scope="col"
                      className="px-6 py-3 lg:w-[360px] cursor-pointer bg-neutral-900  items-center text-left text-[16px] leading-[16px] font-semibold text-white"
                    >
                      <div className="flex items-center gap-2">
                        Location
                        <ArrowsUpDownIcon className="w-5 h-5" />
                      </div>
                    </th>
                    <th
                      onClick={() => handleClick('Date')}
                      scope="col"
                      className="px-6 py-3 flex lg:w-96 cursor-pointer bg-neutral-900  items-center text-left text-[16px] leading-[16px] font-semibold text-white"
                    >
                      <div className="flex items-center gap-2">
                        Date
                        <ArrowsUpDownIcon className="w-5 h-5" />
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-700 bg-inherit">
                  {filteredEventsList?.map((event, indx) => (
                    <tr key={indx}>
                      <td className="text-blue-600 mt-3 whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium  leading-tight sm:pl-6">
                        <a target="_blank" href={`${event?.slug}`}>
                          {event.heading}
                        </a>
                      </td>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-gray-400 text-sm font-medium  leading-tight sm:pl-6">
                        {event.location}
                      </td>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-gray-400 text-sm font-medium  leading-tight sm:pl-6">
                        {moment(event.date).format('MMMM D, YYYY')}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
